document.addEventListener("DOMContentLoaded", () => {
    const buttons = document.querySelectorAll(".accordion-button");

    buttons.forEach(button => {
      button.addEventListener("click", () => {
        const index = button.getAttribute("data-index");
        const sectionId = button.getAttribute("data-section-id");

        const content = document.getElementById(`content-${sectionId}-${index}`);
        const icon = document.getElementById(`icon-${sectionId}-${index}`);

        const minusSVG = `
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M18 15L12 9L6 15" stroke="#1C1511" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `;

        const plusSVG = `
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M6 9L12 15L18 9" stroke="#1C1511" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `;

        if (content.style.maxHeight && content.style.maxHeight !== '0px') {
          content.style.maxHeight = '0';
          icon.innerHTML = plusSVG;
          button.classList.remove('active');
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
          icon.innerHTML = minusSVG;
          button.classList.add('active');
        }
      });
    });
  });
